var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container1"},[_c('div',{class:['box']},[_vm._m(0),_c('div',{class:[_vm.isMobile ? 'success-mobile' : 'success']},[_vm._v(" "+_vm._s(_vm.$t("home.submitted_"))+" ")]),_c('div',{staticClass:"mt-5 underline"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("返回")])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-box"},[_c('i',{staticClass:"el-icon-success icon-check"})])
}]

export { render, staticRenderFns }